import { WbIconDefinition } from './WbIcon';

export const DEFAULT_WITBOOST_ICONS: Record<string, WbIconDefinition> = {
  cue: 'internal:CueIcon',
  cue2: 'internal:Cue2Icon',
  cue_2: 'internal:Cue2Icon',
  remote: 'internal:RemoteIcon',
  remote2: 'internal:Remote2Icon',
  llm: 'internal:LlmIcon',
  llm2: 'internal:Llm2Icon',
  global: 'internal:GlobalIcon',
  global2: 'internal:Global2Icon',
  local: 'internal:LocalIcon',
  local2: 'internal:Local2Icon',
  deploy: 'internal:DeployIcon',
  deploy2: 'internal:Deploy2Icon',
  runtime: 'internal:RuntimeIcon',
  runtime2: 'internal:Runtime2Icon',
  owner: 'internal:OwnerIcon',
  data_contract: 'internal:DataContractIcon',
  user: 'internal:UserIcon',
  group: 'internal:GroupIcon',
  active: {
    value: 'mui:CheckCircle',
    color: 'green',
  },
  disabled: 'internal:DisabledIcon',
  has_access: 'active',
  partial_access: {
    value: 'mui:CheckCircleOutline',
    color: 'green',
  },
  no_access: 'internal:DisabledIcon',
  pending: 'internal:PendingIcon',
  accepted: 'active',
  rejected: 'internal:DisabledIcon',
  download: 'internal:DownloadIcon',
  upload: 'internal:UploadIcon',
  edit: 'internal:EditIcon',
  domain: 'internal:DomainIcon',
  info: 'internal:InfoIcon',
  ok: 'internal:OkeyIcon',
  red_flag: 'internal:RedFlagIcon',
  yellow_flag: 'internal:YellowFlagIcon',
  proposed: 'internal:ProposedIcon',
  wip: 'internal:WipIcon',
  retired: 'internal:DisabledIcon',

  ai_icon: 'internal:AiIcon',
};
